class LoginController {

    constructor(data) {

        var that = this;

        this._popUpCountrySelectorTemplate = null;

        $(document).on('click', '#show-password-register-link',function(e) {
            e.preventDefault();
            $('#show-password-register-link').hide();
            $('#hide-password-register-link').show();
            $('#loginPassword').hideShowPassword(false);
        });

        $(document).on('click', '#hide-password-register-link',function(e) {
            e.preventDefault();
            $('#show-password-register-link').show();
            $('#hide-password-register-link').hide();
            $('#loginPassword').hideShowPassword(true);
        });

        $(document).on("click", '#logouLoginStBtn', function () {
            storage.removeItem('world');

            if (inIframe()) {
                location.href = Routing.generate('front_office_homepage') + "?token=" + world.token;
            }
            else {
                location.href = Routing.generate('front_office_homepage');
            }

        });
        $(document).on("click", '#btnLogin', function () {
            if ($('#loginEmail').val() != '' && $('#loginPassword').val() != '') {

                // If Keycloak client is configured, get OAuth token via Resource Owner Password (fallback flow)
                var clientId = (typeof keycloakAuth !== 'undefined' && keycloakAuth.clientId) ? keycloakAuth.clientId : (localStorage.getItem('kc_client_id') || null);

                function continueLegacyLogin() {
                    const loginUsername = world.login_with_country
                        ? storage.getItem("country") + "_" + $('#loginEmail').val()
                        : $('#loginEmail').val();

                    window.blackBox.setAvatar('ads', loginUsername);
                    window.blackBox.setPhrase('ads', $('#loginPassword').val());

                    // Mirar si hay que redirigir a algun recurso luego del login
                    let redirectResource = $('#btnLogin').data('qsresource');
                    let redirectSubType = $('#btnLogin').data('qssubtype');
                    let redirectWorldToken = $('#btnLogin').data('qsworldtoken');

                    api.login(loginUsername, $('#loginPassword').val(), true, null, false, false, null, function() {
                        if(redirectResource && redirectSubType) {
                            // Esperar a que acaben todas las llamadas para obtener lo necesario antes de ir al contenido
                            $(document).one("ajaxStop", function() {
                                documentationScreenController.shortCuts(redirectSubType, redirectResource, redirectWorldToken);
                            });
                        }
                    });
                }

                if (clientId) {
                    var username = $('#loginEmail').val();
                    var password = $('#loginPassword').val();
                    // console.log("🚀 ~ kc_login from btnLogin click")
                    kc_login(username, password, continueLegacyLogin);
                } else {
                    continueLegacyLogin();
                }

            }
        });

        $(document).on("keypress", '#loginEmail,#loginPassword', function (e) {
            var key = e.which;
            if (key == 13)  // the enter key code
            {
                $( "#btnLogin" ).trigger( "click" );
                return false;
            }
        });

        $(document).on("keypress", '#email,#password', function (e) {
            var key = e.which;
            if (key == 13)  // the enter key code
            {
                $( "#btnRegister" ).trigger( "click" );
                return false;
            }
        });

        $(document).on("click", '#loginShowLoginBtn', function () {
            $('#loginRegisterSection').addClass('hidden');
            $('#loginLoginSection').removeClass('hidden');
            ga('send', 'pageview', analytics.GA_SCREEN_LOGIN);
        });

        // SSO button redirect using server-side auth protocol discovery
        $(document).on('click', '#loginSSOBtn', function (e) {
            e.preventDefault();
            var tokenForWorld = (typeof keycloakAuth !== 'undefined' && keycloakAuth.worldToken) ? keycloakAuth.worldToken : (window.world ? window.world.token : null);
            if (!tokenForWorld && typeof world !== 'undefined') {
                tokenForWorld = world.token;
            }
            if (!tokenForWorld) {
                return;
            }
            api.getWorldAuthProtocols(tokenForWorld, function (authProtocol, worldToken) {
                if (authProtocol) {
                    location.href = Routing.generate('front_third_party_loggin') + "?world_token=" + (worldToken || tokenForWorld);
                }
            });
        });

        $(document).on("focus", '.placeholder-empty', function () {
            $(this).attr('placeholder', '');
        });

        $(document).on("blur", '.placeholder-empty', function () {
            $(this).attr('placeholder', $(this).attr('data-placeholder'));
        });

        $(document).on("keypress", '#tokenInput', function (e) {
            if (e.which == 13) {
                $("#submitTokenBtn").trigger("click");
            }
        });

        $(document).on("click", '#tokenRequest', function (e) {
            swal({
                    title: Translator.trans('TR_REQUEST_TOKEN_TITLE'),
                    text: Translator.trans('TR_RECORDAR_CONTRASENYA_DESCRIPTION'),
                    type: "input",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    closeOnConfirm: false,
                    animation: "slide-from-top",
                    inputPlaceholder: ""
                },

                function (inputValue) {
                    if (inputValue === false) return false;
                    if (inputValue === "") {
                        swal.showInputError(Translator.trans('TR_FIELD_NOT_BLANK'));
                        return false
                    }
                    api.getWorldTokens(inputValue);
                    ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_GET_WORLD_TOKEN, inputValue);
                }
            );
        });

        $(document).on("click", '#submitTokenBtn', function () {
            if (!$("#tokenInput").val()) {
                notify(Translator.trans('TR_DEBE_INTRODUCIR_UN_CODIGO_DE_MUNDO'), "danger");
                return false;
            }

            if (typeof kc_clearStorage === 'function') {
                kc_clearStorage()
            }
            api.getWorldTheme($("#tokenInput").val());
        });


        $(document).on("click", '#loginRememberPassBtn', function () {
            ga('send', 'event', analytics.GA_CATEGORY_LOGIN, analytics.GA_CATEGORY_LOGIN_EVENT_REMEMBER_PASSWORD, '');
        });

        $(document).on("click", '#registerBtn', function () {

            if ($(this).hasClass('register-btn-disabled')) return;

            var name = $("#name").val();
            var surname = $("#last_name").val();
            var email = $("#email").val();
            var telephone = $("#telephone").val();
            var userId = $("#userId").val();
            var key = $("#key").val();
            var error = false;
            var checkboxSelect = api.getCheckboxes();
            var policyAccepted = api.getPolicyAccepted();
            var usePolicyAccepted = api.getUsePolicyAccepted();
            var birthday = $('#birthday').val();

            var categories = [];
            $('#personal-data select').each(function (e) {
                if($(this).val() !== null) {
                    categories.push($(this).val());
                }
            });

            error = error || !api.fieldRequiredFields();

            // Comprobar que la key tenga: Mín. 8 caracteres, mayús., minús., símbolo y número
            var passReg = getPasswordCriteria();
            if (!key.match(passReg)) {
                $('#key').css('border', '2px solid red');
                swal({
                    title: '',
                    text: Translator.trans('TR_LA_CLAVE_NO_CUMPLE_LOS_REQUERIMIENTOS'),
                    type: "warning",
                    confirmButtonText: Translator.trans('TR_ACEPTAR'),
                    closeOnConfirm: true
                });
                error = true;
            }

            // Si está habilitada la politica de privacidad, mirar si esta aceptada
            if(world.privacy_policy_enabled) {
                error = error || !policyAccepted
            }

            // Si está habilitada la politica de uso, mirar si está aceptada
            if (world.use_policy_enabled) {
                error = error || !usePolicyAccepted
            }

            birthday = new Date(birthday).getTime()/1000;

            // Mirar si hay que redirigir a algun recurso luego del login
            let redirectResource = $(this).data('qsresource');
            let redirectSubType = $(this).data('qssubtype');
            let redirectWorldToken = $(this).data('qsworldtoken');

            if(!error) {
                api.register(world.token, userId, userId, key, name, null, surname, email, telephone, birthday, policyAccepted, usePolicyAccepted, checkboxSelect, categories, function() {
                    if(redirectResource && redirectSubType) {
                        return documentationScreenController.shortCuts(redirectSubType, redirectResource, redirectWorldToken)
                    }
                });
            }
        });

        $(document).on("click", ".close-error-message", function () {
            $(this).parent().remove();
        });

        $(document).on("click", ".modal-close-btn, .modal-footer-close-btn", function () {
            $(document).off('click', '#registerLiBtn');
            $(document).off('click', '#registerFbBtn');
            $('#register-modal').modal('hide');
        });
        

        $(document).on("click", ".close-validate-modal", function () {
            $('#register-validation').modal('hide');
        });

        $(document).on('input change', '#register-form input, #register-form select', function () {
            updateRegisterBtn();
        });

        $(document).on("click", '#btnRegister', function () {
            resolveRegistrationType(function (response) {
                if (response && response.type === 'v2') {
                    window.location.href = buildV2RegisterUrl(world, response);
                    return;
                }
                openLegacyRegisterModal();
            });
        });

        $(document).ready(function () {
            var uri = window.location.toString();
            if (uri.indexOf("?") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("?"));
                window.history.replaceState({}, document.title, clean_uri);
            }
        });

        $(document).on('hide.bs.modal', '#register-modal', function () {
            $('#password-register-group').removeClass('hidden');
            $('#registerBtn, #registerFbBtn, #registerLiBtn').addClass('register-btn-disabled');

            $('#register-modal input').each(function () {
                $(this).empty();
            });

            $('.error-div').each(function () {
                $(this).remove()
            });

            $('#registerFbBtn').attr("id", "registerBtn");
            $('#registerLiBtn').attr("id", "registerBtn");
        })
    };

    draw(theme) {
        if (theme.screen_login_background_image && theme.background.is_image_background) {
            if(theme.background.images.length === 1){
                $.backstretch(theme.background.images[0], {speed: 50});
            } else {
                $.backstretch(theme.screen_login_background_image, {speed: 50});
            }
        }

        addThemeStyles(theme);

        if (world.is_public) {
            ga('send', 'pageview', analytics.GA_SCREEN_REGISTRY);
        }
        else {
            ga('send', 'pageview', analytics.GA_SCREEN_LOGIN);
        }

        if (world.theme.login_bg_color) {
            // $('#btnRegister').css('border', '5px solid ' + hex2rgba(world.theme.login_bg_color, 0.5));
            // $('#btnLogin').css('border', '5px solid ' + hex2rgba(world.theme.login_bg_color, 0.5));
        }

        this.loginFromStyles();

        if (world.login_with_country) {
            this.showCountryPopUpSelector();
        }

    };

    showCountryPopUpSelector() {

        this._popUpCountrySelectorTemplate = Handlebars.compile($("#countrySelectorPopUp").html());
        popUpController.setPopUp(this._popUpCountrySelectorTemplate, {});
        popUpController.showPopUp("bottom");

        const selectorData = [];
        let countryCode = "";

        _.forOwn(world.user_countries, function(value, key) {
            selectorData.push({
               id: key,
               text: value,
            });
        });

        $('#country-select').select2({
            dropdownParent: $('.bf-popup'),
            minimumResultsForSearch: Infinity,
            placeholder: Translator.trans("TR_SELECCIONA_PAIS"),
            width: '100%',
            data: selectorData
        });

        $('#country-select').on('select2:open', function () {
            $(".bf-select-chevron-down-icon").attr("class", "bf-select-chevron-down-icon is-select-open");
        });

        $('#country-select').on('select2:close', function () {
            $(".bf-select-chevron-down-icon").attr("class", "bf-select-chevron-down-icon");
        });

        $('#country-select').on('select2:select', function (e) {
            $(".popup-country-selector .action-button").removeClass("disabled");
            const data = e.params.data;
            countryCode = data.id;
        });

        $(".popup-country-selector .action-button").on("click.setCountry", function() {
            storage.setItem("country", countryCode);
            popUpController.hidePopUp();
        });

    }

    goToResourceAfterLoginOrRegister(resource, subType, worldToken) {
        if (resource && subType && worldToken) {
            $('#btnLogin').attr('data-qsresource', resource);
            $('#btnLogin').attr('data-qssubtype', subType);
            $('#btnLogin').attr('data-qsworldtoken', worldToken);

            $('#registerBtn').attr('data-qsresource', resource);
            $('#registerBtn').attr('data-qssubtype', subType);
            $('#registerBtn').attr('data-qsworldtoken', worldToken);
        }
    }

    loginFromStyles() {
        let height = $(window).height();
        let btnBackHeight = $('.back-login-button').outerHeight(true);
        let totalHeight = height-btnBackHeight - 50;    // 30px de margen
        let brandIconHeight = totalHeight - $('.login-forget-pass-row').outerHeight(true) - $('.login-form-row').outerHeight(true) - $('.login-social-buttons-row').outerHeight(true);
        let margins = 45; // 20px de margen de la imagen + 25px del botón de volver atrás
        $('.login-logo-row').css('height', brandIconHeight - margins);
    }
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function getV2Url() {
    var hostname = window.location.hostname.toLowerCase();
    if (hostname.indexOf('localhost') !== -1) return 'http://localhost:5174';
    if (hostname.indexOf('dev') !== -1) return 'https://dev-app.iseazyengage.com';
    if (hostname.indexOf('stg') !== -1) return 'https://stg-app.iseazyengage.com';
    return 'https://app.iseazyengage.com';
};

function buildV2RegisterUrl(world, checkResponse) {
    var theme = (world && world.theme) || {};
    var background = theme.background || {};
    checkResponse = checkResponse || {};

    var params = {
        worldId: world.token,
        color:  theme.base_color || theme.login_button_bg_color || '',
        lang: (world && world.preferred_language) || ''
    };

    if (!background.is_image_background && background.video) {
        params.backgroundVideo = background.video;
    } else if (background.is_image_background && background.images && background.images.length) {
        params.backgroundImage = background.images.join(',');
    }

    var query = Object.keys(params)
        .filter(function (key) { return params[key] !== '' && params[key] != null; })
        .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
        .join('&');

    return getV2Url() + '/register' + (query ? '?' + query : '');
};

function resolveRegistrationType(callback) {
    if (api.registrationTypeCheck) {
        callback(api.registrationTypeCheck);
        return;
    }

    api.checkRegistrationType(world.token, function (response) {
        api.registrationTypeCheck = response || null;
        callback(response);
    }, function () {
        callback(null);
    });
};

function openLegacyRegisterModal() {
    drawFields(world);
    updateRegisterBtn();

    // Clean up any orphaned modal backdrops before showing the modal
    $('.modal-backdrop').each(function () {
        if (!$(this).siblings('.modal:visible').length) {
            $(this).remove();
        }
    });

    // Abrir la modal con el formulario de registro
    $('#register-modal').modal({
        backdrop: true,
        keyboard: true,
        show: true
    });

    if (world.privacy_policy_enabled) {
        $('#privacy-policy-text').empty();
        $('#privacy-policy-title').empty();
        $('#privacy-policy-acceptance').empty();

        $('#privacy-policy-section').removeClass('hidden');
        $('#privacy-policy-text').append(world.privacy_policy_text);
        $('#privacy-policy-title').append(world.privacy_policy_title);
        $('#privacy-policy-acceptance').append(world.privacy_policy_checkox);
    } else {
        $('#privacy-policy-section').addClass('hidden');
    }

    // Politica de uso
    if (world.use_policy_enabled) {
        $('#use-policy-text').empty();
        $('#use-policy-title').empty();
        $('#use-policy-acceptance').empty();

        $('#use-policy-text').append(world.use_policy_text);
        $('#use-policy-title').append(world.use_policy_title);
        $('#use-policy-acceptance').append(world.use_policy_checkbox);
    } else {
        $('#use-policy-section').addClass('hidden');
    }
};

function drawFields(world) {

    $('#personal-data').empty();

    var categories = world.segmentation;
    var fields = world.register_form_fields.fields;
    var sortable = [];

    for(var field in fields) {
        sortable.push([field, fields[field]]);
    }

    for(var cat in categories) {
        sortable.push([cat, categories[cat]]);
    }

    sortable.sort(function (a, b) {
        a = a[1].hasOwnProperty('order') ? a[1].order : a[1].sort;
        b = b[1].hasOwnProperty('order') ? b[1].order : b[1].sort;
        return a - b;
    });

    for(var i in sortable) {
        field = sortable[i];

        if(field[1].subcat) {
            addCategory(field);
        } else {
            addRegisterFormField(field);
        }
    }

    // Añadir los campos login username y password.
    var content =
        '<div class="col-xs-12">' +
        '    <h2>' + Translator.trans("TR_CREDENTIALS") + '</h2>' +
        '</div>' +
        '<div class="form-group col-xs-12">' +
        '    <label class="col-xs-12 placeholder-empty">' + Translator.trans("TR_USERNAME") + '*</label>' +
        '    <input class="col-xs-12 form-control register-input" type="text" id="userId" name="userId" required>' +
        '</div>' +
        '<div class="form-group col-xs-12" id="password-register-group">' +
        '    <label class="col-xs-12 placeholder-empty">' + Translator.trans("TR_CONTRASENA") + '*</label>' +
        '    <input class="col-xs-12 form-control register-input" type="password" id="key" name="key" required>' +
        '    <p class="col-xs-12" id="min8charPass">' + Translator.trans("TR_MIN_8_CARACTERES_Y_ALGUN_SIMBOLO") + '</p>' +
        '</div>';
    $('#personal-data').append(content);
}

function addCategory(cat) {
    var selector = '';
    var catTitle = cat[0];
    var subCategories = cat[1]['subcat'];
    var required = cat[1]['required'];

    selector +=
        '<div class="col-xs-12 form-group">' +
        '<label for="privacy-policy-version-selector">' + catTitle;

    if(required) {
        selector += '*';
    }

    selector +=
        '</label>' +
        '<select id="segment-selector-' + catTitle + '" name="privacy-policy-version-selector" class="form-control register-input"';

    if(required) {
        selector += ' required ';
    }

    selector +=
        '>' +
        '<option value="" disabled selected>' + sprintf(Translator.trans('TR_SELECCIONA'), catTitle.toLowerCase()) + '</option>';
    for(var subCat in subCategories) {
        var subCatTitle = subCategories[subCat];
        selector += '<option class="black" value="' + subCat + '">' +subCatTitle + '</option>';
    }

    selector += '</select></div>';
    $('#personal-data').append(selector);
}

function checkRegisterFormValid() {
    var valid = true;

    $('#register-form [required]').each(function () {
        if ($(this).is('input[type="checkbox"]')) {
            if (!$(this).is(':checked')) {
                valid = false;
                return false; // break
            }
        } else {
            var val = $(this).val();
            if (!val || val.trim() === '') {
                valid = false;
                return false; // break
            }
        }
    });

    if (valid && typeof world !== 'undefined') {
        if (world.privacy_policy_enabled && !$('#privacy-policy').is(':checked')) {
            valid = false;
        }
        if (valid && world.use_policy_enabled && !$('#use-policy').is(':checked')) {
            valid = false;
        }
    }

    return valid;
}

function updateRegisterBtn() {
    var $btn = $('#registerBtn, #registerFbBtn, #registerLiBtn');
    if (checkRegisterFormValid()) {
        $btn.removeClass('register-btn-disabled');
    } else {
        $btn.addClass('register-btn-disabled');
    }
}

function addRegisterFormField(field) {
    var content = '';
    field = field[1];

    content += '<div class="form-group col-xs-12"><label class="col-xs-12 placeholder-empty">' + field.label;
    if (field.required) {
        content += '*'
    }
    content += '</label>';

    content += '<input class="col-xs-12 form-control register-input" type="';
    if (field.id === 'email') {
        content += 'email';
    } else if (field.id === 'birthday') {
        content += 'date';
    } else {
        content += 'text';
    }
    content += '" id="' + field.id +'" name="' + field.id + '"';
    if (field.required) {
        content += ' required';
    }
    content += '></div>';

    $('#personal-data').append(content);
}